// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SearchCasesResponseModel {
    static getAttributeTypeMap() {
        return SearchCasesResponseModel.attributeTypeMap;
    }
}
SearchCasesResponseModel.discriminator = undefined;
SearchCasesResponseModel.attributeTypeMap = [
    {
        "name": "intakeCase",
        "baseName": "intakeCase",
        "type": "CaseModel"
    },
    {
        "name": "workflows",
        "baseName": "workflows",
        "type": "Array<SearchWorkflowsResponseModel>"
    }
];
//# sourceMappingURL=searchCasesResponseModel.js.map